import type {AdBreak, AdBreakConfig, AdConfig, AdManifestLoadedEvent, AdTagConfig} from 'bitmovin-player';

import * as Utils from '../utils/Utils';

import {ErrorSeverity} from './AnalyticsConfig';

export class AdBreakSample {
  adPosition?: string;
  adOffset?: string;
  adScheduleTime?: number;
  adReplaceContentDuration?: number;
  adPreloadOffset?: number;
  adTagPath?: string;
  adTagServer?: string;
  adTagType?: string;
  adTagUrl?: string;
  adIsPersistent?: boolean;
  adIdPlayer?: string;
  manifestDownloadTime?: number;
  errorCode?: number;
  errorData?: string;
  errorMessage?: string;
  errorSeverity?: ErrorSeverity;
  adFallbackIndex = 0;

  constructor(adConfig?: AdConfig, adManifestLoadedEvent?: AdManifestLoadedEvent) {
    if (adManifestLoadedEvent) {
      this.manifestDownloadTime = Utils.calculateTime(adManifestLoadedEvent.downloadTiming.downloadTime);
    }

    if (adConfig) {
      this.adReplaceContentDuration = Utils.calculateTimeWithUndefined(adConfig.replaceContentDuration);
      this.adFallbackIndex = ((adConfig as any).currentFallbackIndex || -1) + 1;
    }

    const adBreakConfig = adConfig as AdBreakConfig;
    if (adBreakConfig) {
      if (adBreakConfig.position === 'pre' || adBreakConfig.position === 'post') {
        this.adPosition = adBreakConfig.position;
      } else {
        this.adPosition = 'mid';
        this.adOffset = adBreakConfig.position;
      }

      this.adPreloadOffset = Utils.calculateTimeWithUndefined(adBreakConfig.preloadOffset);
    }

    const adTagConfig = adConfig as AdTagConfig;
    if (adTagConfig) {
      this.adIsPersistent = adTagConfig.persistent;
      let tag = adTagConfig.tag;
      if (
        this.adFallbackIndex > 0 &&
        adTagConfig.fallbackTags &&
        adTagConfig.fallbackTags.length >= this.adFallbackIndex
      ) {
        tag = adTagConfig.fallbackTags[this.adFallbackIndex - 1];
      }
      if (tag) {
        this.adTagType = tag.type;
        this.adTagUrl = tag.url;
      }
      if (this.adTagUrl) {
        try {
          const adTagUrl = new URL(this.adTagUrl);
          this.adTagServer = adTagUrl.hostname;
          this.adTagPath = adTagUrl.pathname;
        } catch {
          // Invalid URL, leave fields undefined
        }
      }
    }

    const adBreak = adConfig as AdBreak;
    if (adBreak) {
      this.adScheduleTime = Utils.calculateTimeWithUndefined(adBreak.scheduleTime);
      this.adIdPlayer = adBreak.id;
    }
  }
}
